/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OrderConfirmationTotalsComponent } from '@spartacus/order/components';
import { OrderFacade } from '@spartacus/order/root';
import { OrderSummaryComponent } from '../../../cart-shared/order-summary/order-summary.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'cx-order-confirmation-totals',
    templateUrl: './order-confirmation-totals.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OrderSummaryComponent, AsyncPipe]
})
export class UdxOrderConfirmationTotalsComponent extends OrderConfirmationTotalsComponent {
  constructor(orderFacade: OrderFacade) {
    super(orderFacade);
  }
}
